/**
 * Stato del follow-up di un processo: in scadenza oggi, già scaduto, o niente da segnalare.
 *
 * Regole pure, senza store né i18n. Prima vivevano duplicate in ProjectsTable e Dashboard; la
 * pagina del carico di lavoro è il terzo posto che ne ha bisogno, e tre copie della stessa data
 * sono tre modi di sbagliarla.
 *
 * Gli stati senza intervallo di follow-up (i terminali, tipo "Pago") non hanno scadenza da
 * segnalare, anche quando si portano dietro un `reminderDate` vecchio.
 */
import { now } from './dateUtils.js'

/** Data di oggi come "YYYY-MM-DD" nel fuso locale, rispettando la modalità test. */
export const todayKey = () => {
  const today = now()
  return today.getFullYear() + '-' +
    String(today.getMonth() + 1).padStart(2, '0') + '-' +
    String(today.getDate()).padStart(2, '0')
}

/**
 * @returns {'none'|'today'|'overdue'}
 */
export const followUpState = (project, statusInfo) => {
  if (!project?.reminderDate) return 'none'
  if (!statusInfo || !statusInfo.followUpDays) return 'none'

  // Solo la parte data: ora e fuso della stringa non contano
  const reminder = project.reminderDate.substring(0, 10)
  const today = todayKey()

  if (reminder === today) return 'today'
  return reminder < today ? 'overdue' : 'none'
}

/** Da quanti giorni il follow-up è scaduto. Almeno 1, e 0 se non è scaduto. */
export const overdueDays = (project) => {
  if (!project?.reminderDate) return 0

  const [y, m, d] = project.reminderDate.substring(0, 10).split('-').map(Number)
  if (!y || !m || !d) return 0

  const due = new Date(y, m - 1, d)
  const today = now()
  today.setHours(0, 0, 0, 0)

  const days = Math.round((today - due) / 86400000)
  return days > 0 ? days : 0
}
